<div class="sr-popup" *ngIf="visible">
  <!-- Header -->
  <div class="sr-popup__header">
    <span class="sr-popup__title f-14">Signup Requests ({{ pendingCount }})</span>
    <i class="pi pi-times sr-popup__close" (click)="close()" title="Close" aria-label="Close"></i>
  </div>

  <!-- Status tabs -->
  <div class="sr-popup__tabs">
    <button type="button" *ngFor="let tab of tabs" class="sr-tab" [class.sr-tab--active]="status === tab.key" (click)="setStatus(tab.key)">
      {{ tab.label }}
    </button>
  </div>

  <!-- Body -->
  <div class="sr-popup__body">
    <p *ngIf="loading" class="sr-popup__state">Loading…</p>

    <p *ngIf="!loading && requests.length === 0" class="sr-popup__state">No {{ status }} requests.</p>

    <div class="sr-row" *ngFor="let request of requests; trackBy: trackById">
      <div class="sr-row__main">
        <div class="sr-row__info">
          <p class="sr-row__name _fw-600">{{ request.name }}</p>
          <p class="sr-row__line f-10">{{ request.companyName }}</p>
          <p class="sr-row__line f-10">{{ request.email }}</p>
          <p class="sr-row__line f-10">{{ request.mobile }}</p>

          <!-- CRM sync status for approved requests -->
          <p *ngIf="request.approvalStatus === 'approved'" class="sr-badge" [ngClass]="'sr-badge--' + (request.crmSyncStatus || 'pending')">
            CRM:
            <ng-container [ngSwitch]="request.crmSyncStatus">
              <span *ngSwitchCase="'synced'">Synced</span>
              <span *ngSwitchCase="'failed'">Failed — retry approve</span>
              <span *ngSwitchDefault>Syncing…</span>
            </ng-container>
          </p>

          <!-- Rejection reason -->
          <p *ngIf="request.approvalStatus === 'rejected' && request.rejectionReason" class="sr-row__line sr-row__reason">
            Reason: {{ request.rejectionReason }}
          </p>
        </div>

        <!-- Row actions -->
        <div class="sr-row__actions">
          <button
            type="button"
            *ngIf="canApprove(request)"
            class="sr-btn sr-btn--approve"
            [disabled]="busyId === request._id"
            (click)="approve(request)"
            [title]="request.crmSyncStatus === 'failed' ? 'Retry CRM sync' : 'Approve'"
            [attr.aria-label]="request.crmSyncStatus === 'failed' ? 'Retry CRM sync' : 'Approve'">
            <i class="pi f-12" [ngClass]="request.crmSyncStatus === 'failed' ? 'pi-refresh' : 'pi-check'"></i>
          </button>

          <button
            type="button"
            *ngIf="status === 'pending'"
            class="sr-btn sr-btn--reject"
            [disabled]="busyId === request._id"
            (click)="toggleReject(request)"
            title="Reject"
            aria-label="Reject">
            <i class="pi pi-times f-12"></i>
          </button>

          <button
            type="button"
            class="sr-btn sr-btn--delete"
            [disabled]="busyId === request._id"
            (click)="openDeleteDialog(request)"
            title="Delete"
            aria-label="Delete">
            <i class="pi pi-trash f-12"></i>
          </button>
        </div>
      </div>

      <!-- Inline reject-reason panel -->
      <div class="sr-reject" *ngIf="rejectingId === request._id">
        <input
          type="text"
          class="sr-reject__input"
          placeholder="Reason (optional)"
          [(ngModel)]="rejectReason"
          (keyup.enter)="confirmReject(request)" />
        <div class="sr-reject__actions">
          <button type="button" class="sr-reject__cancel" (click)="toggleReject(request)">Cancel</button>
          <button type="button" class="sr-reject__confirm" [disabled]="busyId === request._id" (click)="confirmReject(request)">Reject</button>
        </div>
      </div>
    </div>
  </div>
</div>
